import { render } from "./HomeCourse.vue?vue&type=template&id=5c00f53e&scoped=true"
import script from "./HomeCourse.vue?vue&type=script&lang=js"
export * from "./HomeCourse.vue?vue&type=script&lang=js"

import "./HomeCourse.vue?vue&type=style&index=0&id=5c00f53e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c00f53e"]])

export default __exports__